import { monteurApi } from '../common/monteur-api';
export var microsoftSpeechApi = monteurApi.injectEndpoints({
    endpoints: function (builder) { return ({
        synthesizeSpeech: builder.mutation({
            query: function (body) { return ({
                url: 'Speech/synthesize',
                method: 'POST',
                body: body,
                responseHandler: function (response) { return response.arrayBuffer(); }
            }); }
        })
    }); }
});
export var useSynthesizeSpeechMutation = microsoftSpeechApi.useSynthesizeSpeechMutation;
